var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindow2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "window_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "window_2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(57.000000, 23.000000)",
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    points: "0 0 8 3.1175818 8 66.9478302 0 64.0551069"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    points: "12 0 20 3.1175818 20 66.9478302 12 64.0551069"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    points: "12 0 20 3.1175818 20 66.9478302 12 64.0551069"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    points: "25 0 33 3.1175818 33 66.9478302 25 64.0551069"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(10.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#4A4A4A",
    transform: "translate(4.000000, 33.473915) scale(-1, 1) translate(-4.000000, -33.473915) ",
    points: "0 0 8 3.1175818 8 66.9478302 0 64.0551069"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#D8D8D8",
    transform: "translate(16.000000, 33.473915) scale(-1, 1) translate(-16.000000, -33.473915) ",
    points: "12 0 20 3.1175818 20 66.9478302 12 64.0551069"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#4A4A4A",
    transform: "translate(16.000000, 33.473915) scale(-1, 1) translate(-16.000000, -33.473915) ",
    points: "12 0 20 3.1175818 20 66.9478302 12 64.0551069"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#D8D8D8",
    transform: "translate(29.000000, 33.473915) scale(-1, 1) translate(-29.000000, -33.473915) ",
    points: "25 0 33 3.1175818 33 66.9478302 25 64.0551069"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 10,
    y: 16,
    width: 80,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4A4A4A",
    x: 10,
    y: 16,
    width: 80,
    height: 4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindow2);
export default __webpack_public_path__ + "static/media/window_2.f1e840b48968afc612f12b5a94c20277.svg";
export { ForwardRef as ReactComponent };